import { z } from "zod/v4";
export const supportedHolidayZones = [
    "alsace-moselle",
    "guadeloupe",
    "guyane",
    "la-reunion",
    "martinique",
    "mayotte",
    "metropole",
    "nouvelle-caledonie",
    "polynesie-francaise",
    "saint-barthelemy",
    "saint-martin",
    "saint-pierre-et-miquelon",
    "wallis-et-futuna",
];
export const holidayZoneSchema = z.enum(supportedHolidayZones);
export const holidayZoneLabels = {
    "alsace-moselle": "Alsace-Moselle",
    guadeloupe: "Guadeloupe",
    guyane: "Guyane",
    "la-reunion": "La Reunion",
    martinique: "Martinique",
    mayotte: "Mayotte",
    metropole: "Metropole",
    "nouvelle-caledonie": "Nouvelle-Caledonie",
    "polynesie-francaise": "Polynesie francaise",
    "saint-barthelemy": "Saint-Barthelemy",
    "saint-martin": "Saint-Martin",
    "saint-pierre-et-miquelon": "Saint-Pierre-et-Miquelon",
    "wallis-et-futuna": "Wallis-et-Futuna",
};
//# sourceMappingURL=PublicHolidays.js.map